import { render, staticRenderFns } from "./ThrottleBtn.vue?vue&type=template&id=5a47503d&scoped=true"
import script from "./ThrottleBtn.vue?vue&type=script&lang=js"
export * from "./ThrottleBtn.vue?vue&type=script&lang=js"
import style0 from "./ThrottleBtn.vue?vue&type=style&index=0&id=5a47503d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47503d",
  null
  
)

export default component.exports